import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-cross",
  "use": "icon-s-cross-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-cross\"><path fill-rule=\"evenodd\" d=\"M12.9142136 11.5 19.631728 18.2175144 18.2175144 19.631728 11.5 12.9142136 4.78248558 19.631728 3.36827202 18.2175144 10.0857864 11.5 3.36827202 4.78248558 4.78248558 3.36827202 11.5 10.0857864 18.2175144 3.36827202 19.631728 4.78248558z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol